<template>
  <div class="static-dialog load-dialog">
    <el-form :model="forms" :rules="rules" ref="forms" label-width="100px" size="large">
      <el-row>
        <el-col :xs="24">
          <el-form-item label="旧密码" prop="oldpassword">
            <el-input v-model="forms.oldpassword"
              :placeholder="disableOldPwd ? '管理员重置他人密码无需输入旧密码' : '请输入账户原密码'"
              :disabled="disableOldPwd" autocomplete="off" style="max-width: 250px" show-password></el-input>
          </el-form-item>
          <el-form-item v-if="disableOldPwd" label-width="100px" style="margin-top: -10px;">
            <el-alert title="您当前为管理员角色，重置他人密码无需校验旧密码。" type="info" :closable="false" show-icon
              style="max-width: 360px;"></el-alert>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24">
          <el-form-item label="新密码" prop="newpassword">
            <el-input v-model="forms.newpassword" placeholder="请输入账户新密码" autocomplete="off" style="max-width: 250px"
              show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24">
          <el-form-item label="确认密码" prop="confirmpassword">
            <el-input v-model="forms.confirmpassword" placeholder="请重复输入账户新密码" autocomplete="off"
              style="max-width: 250px" show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- <template #footer>
        <span class="dialog-footer">
          <el-button @click="visible = false" size="large">取 消</el-button>
          <el-button type="primary" @click="resetPwd()" size="large">确 定</el-button>
        </span>
      </template> -->
  </div>
</template>


<script>
import { resetUserPwd } from "@/api/sys";
import { logout } from "@/api/login";

export default {
  name: "reset",
  components: {},
  props: {
    user: {
      type: Object,
      default: {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "重置密码",
    },
  },
  data() {
    return {
      forms: {},
      rules: {
        oldpassword: [
          { min: 0, max: 30, message: "请输入账号原密码", trigger: "blur" },
        ],
        newpassword: [
          { min: 6, max: 30, message: "密码长度需为6-30位", trigger: "blur" },
        ],
        confirmpassword: [
          { min: 6, max: 30, message: "密码长度需为6-30位", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 是否禁用旧密码输入框：当前登录人是管理员，且正在为他人重置密码
    disableOldPwd() {
      const userInfo = (this.$store && this.$store.state && this.$store.state.userInfo) || {};
      const roles = userInfo.roles || [];
      const isAdmin = Array.isArray(roles) && roles.some((r) => String(r).toLowerCase() === "admin");
      const targetId = this.user && this.user.id;
      const isResettingOther = !!targetId && targetId !== userInfo.userID;
      return isAdmin && isResettingOther;
    },
  },
  methods: {
    resetPwd(redirect) {
      this.forms.id = "";
      if (this.user && this.user.id) this.forms.id = this.user.id;
      // 管理员为他人重置密码时，不传旧密码
      if (this.disableOldPwd) {
        this.forms.oldpassword = "";
      }
      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        if (!!!this.forms.newpassword) {
          this.$message.error("请输入新密码~");
          return;
        }

        if (this.forms.newpassword != this.forms.confirmpassword) {
          this.$message.error("两次输入新密码不一致~");
          return;
        }

        // 新密码规则：长度 6-30 位、字母+数字组合、不允许空白字符
        if (!/^(?=.*[A-Za-z])(?=.*\d)[^\s]{6,30}$/.test(this.forms.newpassword)) {
          this.$message.error("新密码格式不合规（6-30 位，且需字母+数字组合）~");
          return;
        }

        resetUserPwd(this.forms).then((res) => {
          if (res.code === 200) {
            this.$message({ type: "success", message: res.content });
            if (redirect) {
              setTimeout(function () {
                logout();
              }, 1000);
            }
          }
        }).catch((err) => {
          this.$message.error(err.message || "密码重置失败，请稍后重试");
        });
      });
    },
  },
  created() {
  },
  mounted() { },
};
</script>
